import { render } from "./VagasPage.vue?vue&type=template&id=4d1fca14&scoped=true"
import script from "./VagasPage.vue?vue&type=script&lang=js"
export * from "./VagasPage.vue?vue&type=script&lang=js"

import "./VagasPage.vue?vue&type=style&index=0&id=4d1fca14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d1fca14"]])

export default __exports__